const IS_DESKTOP = window.innerWidth > 1280;
const IS_TABLET = window.innerWidth <= 1280 && window.innerWidth >= 768;
const IS_MOBILE = window.innerWidth < 768;

(() => {
  //CHECK IOS DEVICE
  //================================
  if (/(iPad|iPhone|iPod|MacIntel)/.test(navigator.userAgent) && !window.MSStream) {
    document.body.setAttribute('device', 'iOS');
  }

  //SET A CUSTOM CURSOR TO ELEMENTS
  //================================
  const setCursor = () => {
    let targetButtons = document.querySelectorAll('.btn-magnet'), hoverButton = null;

    // create tooltip
    let tooltip = document.querySelector('.tooltip');

    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.classList.add('tooltip');
      document.body.append(tooltip);

      let isHoveringTarget = false;
      let lastX = 0, lastY = 0;

      // initial position

      const followMouse = (e) => {
        if (!isHoveringTarget) {
          lastX = e.clientX;
          lastY = e.clientY;

        }
      };

      targetButtons.forEach(btn => {
        btn.addEventListener('mouseenter', () => {
          isHoveringTarget = true;
          
          requestAnimationFrame(() => {
            const rect = btn.getBoundingClientRect();
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;
            // Значения centerX и centerY не используются, но оставляем для совместимости
          });

          tooltip.classList.add('magnet');
        });

        btn.addEventListener('mouseleave', () => {
          isHoveringTarget = false;

          tooltip.classList.remove('magnet');
        });
      });

      document.addEventListener('mousemove', followMouse);
    }
  }

  window.addEventListener('DOMContentLoaded', () => {
    window.innerWidth >= 1280 ? setCursor() : false;
  });

  //SET NUMBER CLUTCH REVIEW
  //========================
  const clutchReviews = document.querySelectorAll('.clutch-reviews');

  const setNumberClutchReview = () => {
    const NUMBERS_OF_REVIEWS = 52;

    clutchReviews.forEach(elem => elem.innerText = NUMBERS_OF_REVIEWS)
  }

  clutchReviews[0] ? setNumberClutchReview() : false;



  // fade animation
  let container = document.querySelector('main');
  container.classList.add('animation-wrap');

  function createWaypoint(selector, className) {
    const elements = document.querySelectorAll(selector);

    elements.forEach(element => {
      const waypoint = new IntersectionObserver(entries => {

        entries.forEach(entry => {
          if (entry.isIntersecting) {
            element.classList.add(className);
            waypoint.unobserve(element);
          }
        });
      }, {
        threshold: 0.75,
        rootMargin: '10px'
      });

      waypoint.observe(element);
    });
  }

  createWaypoint('.fade-up', 'fadeUp');
  createWaypoint('.fade-bottom', 'fadeBottom');
  createWaypoint('.fade-left', 'fadeLeft');
  createWaypoint('.fade-right', 'fadeRight');
  createWaypoint('.fade', 'fadeNone');


  //SCROLL TO TOP
  //================================
  if (document.querySelector('.content-nav__btn-top')) {
    document.querySelector('.content-nav__btn-top').addEventListener('click', () => {
      window.scroll(0,0);
    });
  }

  //OPEN\CLOSE HEADER MENU
  //================================
  const header = document.querySelector('.header'),
    headerNav = document.querySelector('.header-nav'),
    contactUsBtn = document.querySelector('.header-nav__link.btn'),
    headerMenuBtn = document.querySelector('.header-nav__btn'),
    headerNavLink = document.querySelectorAll('.header-nav__wrap > .header-nav__link');
  headerNavPrev = document.querySelectorAll('.header-menu-services__prev');

  const resetMobileMenu = () => {
    let openElems = headerNav.querySelectorAll('.open');
    let activeElems = headerNav.querySelectorAll('.active');

    openElems.forEach(elem => elem.classList.remove('open'));
    activeElems.forEach(elem => elem.classList.remove('active'));
  }

  const changeParentBtnHeader = () => {
    if (!contactUsBtn) return;

    header.insertBefore(contactUsBtn, headerMenuBtn);
  }

  headerMenuBtn.addEventListener('click', () => {

    document.body.classList.toggle('fix');
    headerMenuBtn.classList.toggle('open');
    headerNav.classList.toggle('open');

    if (!headerMenuBtn.classList.contains('open')) resetMobileMenu();
  });

  const openСhapterMenu = (elems, link) => {
    elems.forEach(elem => {
      elem.classList.remove('active');
      elem.nextElementSibling.classList.remove('open');
    });
    link.classList.add('active');
    link.nextElementSibling.classList.add('open');
  }

  headerNavLink.forEach(elem => elem.addEventListener('click', (event) => {
    event.preventDefault();
    openСhapterMenu(headerNavLink, elem);
  }));

  headerNavPrev.forEach(btn => btn.addEventListener('click', () => {
    resetMobileMenu();
  }));

  if (IS_TABLET) changeParentBtnHeader();

  //================================
  const headerCategories = document.querySelector('.header-categories');

  if (header && headerCategories) {
    let lastScrollY = window.scrollY;
    const SCROLL_THRESHOLD = 100;
    let rafId = null;
    let lastUpdateTime = 0;
    const updateInterval = 16;

    const handleHeaderScroll = (currentScrollY) => {
      const isScrollingDown = currentScrollY > lastScrollY;

      if (headerMenuBtn && headerMenuBtn.classList.contains('open')) {
        lastScrollY = currentScrollY;
        return;
      }

      if (currentScrollY <= SCROLL_THRESHOLD) {
        header.classList.remove('header--hidden');
        headerCategories.classList.remove('header-categories--scrolled');
        lastScrollY = currentScrollY;
        return;
      }

      if (isScrollingDown) {
        header.classList.add('header--hidden');
        headerCategories.classList.add('header-categories--scrolled');
      } else {
        header.classList.remove('header--hidden');
        headerCategories.classList.remove('header-categories--scrolled');
      }

      lastScrollY = currentScrollY;
    };

    const scheduleScroll = () => {
      const now = performance.now();
      
      if (now - lastUpdateTime < updateInterval) {
        if (rafId !== null) {
          return;
        }
      }

      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
      
      const currentScrollY = window.scrollY;
      
      rafId = requestAnimationFrame(() => {
        lastUpdateTime = performance.now();
        handleHeaderScroll(currentScrollY);
        rafId = null;
      });
    };

    window.addEventListener('scroll', scheduleScroll, { passive: true });
  }

  //OPEN\CLOSE ELEMS FAQ
  //========================
  const faqItems = document.querySelectorAll('.faq-list__item');

  if (faqItems[0]) {
    faqItems.forEach(elem => elem.addEventListener('click', () => {
      const answers = elem.querySelector('.faq-list__answers');
      if (!answers) return;

      switch (elem.classList.contains('faq-list__item_open')) {
        case true:
          elem.classList.remove('faq-list__item_open');
          answers.style.height = 0;
          break;

        default:
          for (let item of faqItems) {
            item.classList.remove('faq-list__item_open');
            const itemAnswers = item.querySelector('.faq-list__answers');
            if (itemAnswers) {
              itemAnswers.style.height = 0;
            }
          }

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const scrollHeight = answers.scrollHeight;
              answers.style.height = scrollHeight + 'px';
              elem.classList.add('faq-list__item_open');
            });
          });
      }
    }));
  }

  // VALIDATION FORMS
  //========================
  const formsHandler = {
    handleInput: function (event) {
      if (event.target.classList.contains('required')) formsHandler.validateField(this, event.target);
    },

    bindEvents: function (self) {
      this.form = self;

      for (let input of self.requiredInputs) {
        input.addEventListener('input', this.handleInput.bind(self));
        input.addEventListener('blur', this.handleInput.bind(self));
      }

      self.form.addEventListener('submit', this.handleSubmit.bind(self));

      if (self.inputFile) {
        self.inputFile.addEventListener('change', () => this.handleFileInput(self));
      }
    },

    validateField: function (self, input) {
      const fieldName = input.name;
      let isValid = true;

      input.type !== 'email' ? isValid = !(input.value === '') : isValid = this.isValidEmail(input);

      this.updateFieldState(self, input, fieldName, isValid);
    },

    updateFieldState: function (self, input, fieldName, isValid) {
      self.validationState[fieldName] = isValid;

      input.parentElement.classList.toggle('valid', isValid);
      input.parentElement.classList.toggle('invalid', !isValid);
    },

    validateAllFields: function (self) {
      self.requiredInputs.forEach(input => this.validateField(self, input));
      return !Object.values(self.validationState).includes(false);
    },

    isValidEmail(email) {
      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        emailBlackList = ['hotmail.com','yahoo.com','gmail.com','outlook.com','prontomail.com','mail.com'];

      if (email.value === '') {
        email.parentElement.classList.add('invalid');
        email.nextElementSibling.innerText = 'Email is required';
        return false;
      } else {

        if (!email.value.match(regex)) {
          email.parentElement.classList.add('invalid');
          email.nextElementSibling.innerText = 'Enter email in the format name@example.com';
          return false;
        } else {
          let str = email.value.split('@').at(-1).toLowerCase();

          for (let elem of emailBlackList) {
            if (elem === str) {
              email.nextElementSibling.innerText = 'Please enter your business email';
              return false;
            }
          }

          return true;
        }
      }
    },

    handleFileInput: function (self) {
      const fileNameHtmlElement = self.form.querySelector('.input-file-wrap__file-name');

      if (fileNameHtmlElement) fileNameHtmlElement.remove();

      if (self.inputFile.files[0].size < 10000000) {
        const div = document.createElement('div'),
          elementTextNameFile = document.createElement('span'),
          button = document.createElement('button');

        div.classList.add('input-file-wrap__file-name');
        elementTextNameFile.classList.add('input-file-wrap__file-name-text');

        const format = self.inputFile.files[0].name.split('.');

        div.append(elementTextNameFile);
        div.prepend(`.${format[1]}`);

        elementTextNameFile.innerText = format[0];

        button.addEventListener('click', () => {
          button.parentElement.remove();
          self.inputFile.value = '';
        });

        div.append(button);

        self.inputFile.parentElement.classList.remove('invalid');
        self.inputFile.closest('.input-file-wrap').append(div);
      } else {
        self.inputFile.parentElement.classList.add('invalid');
      }
    },

    handleSubmit(event) {
      event.preventDefault();

      const isFormValid = formsHandler.validateAllFields(this);
      let serviceSelected = false;

      if (!isFormValid && this.steeps && this.validationState['services']) {
        this.handleNextSteep();
      }

      if (this.servicesInputs) {
        serviceSelected = this.handleNextSteep();

        if (isFormValid && serviceSelected) {
          formsHandler.sendData(this);
        }
      } else if (isFormValid) {
        formsHandler.sendData(this);
      }
    },

    async sendData(self) {
      const formData = new FormData(self.form);

      if (self.inputFile && self.inputFile.files[0]) {
        formData.append('contact_request_files_attributes[][file]', self.inputFile.files[0]);
      }

      if (self.servicesInputs) {
        for (let service of self.servicesInputs) {
          if (service.checked) {
            formData.append('goals[]', service.value)
          }
        }
      }

      try {
        const response = await fetch('/api/v1/contact_requests.json', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) {
          throw new Error(response.statusText);
        }

        document.querySelector('.form-feedback-popup').classList.add('view');
        document.body.classList.add('fix');
        self.form.reset();

        self.form.querySelectorAll('.valid').forEach(elem => elem.classList.remove('valid'));
        document.querySelector('.tooltip').classList.add('hidden');

      } catch (error) {
        console.error(error);
      }
    }
  }

  // FORM FEEDBACK
  //========================
  const feedbackFormHandler = {
    'form': document.querySelector('#form-feedback'),

    validationState: {},

    init() {
      if (!this.form) return;

      this.requiredInputs = this.form.querySelectorAll('.required');

      this.requiredInputs.forEach(input => {
        this.validationState[input.name] = false;
      });

      this.inputFile = this.form.querySelector('input[type="file"]');

      formsHandler.bindEvents(this);
    }
  }

  // FORM QUIZ
  //========================
  const quizFormHandler = {
    'form': document.querySelector('#form-quiz'),

    validationState: {},

    init() {
      if (!this.form) return;

      this.requiredInputs = this.form.querySelectorAll('.required');
      this.servicesInputs = this.form.querySelectorAll('[name="services1"]');
      this.steeps = this.form.querySelectorAll('.form-quiz-steep');
      this.nextSteepButton = this.form.querySelector('.form-quiz__btn');

      this.requiredInputs.forEach(input => {
        this.validationState[input.name] = false;
      });

      this.validationState['services'] = false;

      this.inputFile = this.form.querySelector('input[type="file"]');

      this.bindEvents();
    },

    bindEvents() {
      if (this.nextSteepButton) {
        this.nextSteepButton.addEventListener('click', this.handleNextSteep.bind(this));
      }

      this.servicesInputs.forEach(service => service.addEventListener('change', this.handleServices.bind(service, this)));
      formsHandler.bindEvents(this);
    },

    handleServices(self) {
      self.validationState['services'] = false;

      for (let input of self.servicesInputs) {
        if (input.checked) {
          self.validationState['services'] = true;
          break;
        }
      }
    },

    handleNextSteep() {
      this.handleServices(this);

      if (this.validationState['services']) {
        this.steeps[0].classList.add('valid');
        this.steeps[0].classList.remove('invalid');
        this.steeps[1].classList.remove('hidden');

        if (this.nextSteepButton) this.nextSteepButton.classList.add('hidden');
        return true;
      } else {
        this.steeps[0].classList.add('invalid');
        return false;
      }
    }
  }

  //FORM POPUP
  //================================
  let formFeedbackPopup = document.querySelector('.form-feedback-popup');

  if (formFeedbackPopup) {
    formFeedbackPopup.addEventListener('click', () => {
      formFeedbackPopup.classList.remove('view');
      document.body.classList.remove('fix');
    });
  }


  //SECTION SERVICES ANIMATION
  //================================
  let servicesItem = document.querySelectorAll('.services-list__item');

  const serviceCardAnimation = () => {
    if (!servicesItem.length) return;

    const deactivateAll = (items) => {
      items.forEach(item => item.classList.contains('active') && (item.classList.remove('active'), item.style.height = ''));
    }

    const activeItem = (item) => {
      deactivateAll(servicesItem);

      if (IS_DESKTOP || IS_TABLET) {
        // Используем двойной requestAnimationFrame для гарантии, что стили применены
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const scrollHeight = item.scrollHeight;
            item.style.height = scrollHeight + 'px';
          });
        });
      }
      item.classList.add('active');
    }

    servicesItem.forEach(item => item.addEventListener('mouseenter', () => {
      !item.classList.contains('active') ? activeItem(item) : false;
    }));
  }

  serviceCardAnimation();
  quizFormHandler.init();
  feedbackFormHandler.init();

  // Apply responsive background images from data attributes
  //================================
  const applyResponsiveBackgrounds = () => {
    const updateBackgrounds = () => {
      const width = window.innerWidth;
      const menus = document.querySelectorAll('.header-menu-services');
      
      menus.forEach(menu => {
        // Find the first wrap that has data attributes (promo block or first card)
        const firstWrap = menu.querySelector('.header-menu-services__wrap[data-image-tablet], .header-menu-services__wrap[data-image-mobile], .header-menu-services__wrap[style*="--bg-image"]');
        if (!firstWrap) return;
        
        if (width < 768) {
          // Mobile
          const mobileImage = firstWrap.getAttribute('data-image-mobile');
          if (mobileImage) {
            firstWrap.style.setProperty('--bg-image-mobile', `url(${mobileImage})`);
            firstWrap.style.backgroundImage = `url(${mobileImage})`;
          }
        } else if (width <= 1280) {
          // Tablet
          const tabletImage = firstWrap.getAttribute('data-image-tablet');
          if (tabletImage) {
            firstWrap.style.setProperty('--bg-image-tablet', `url(${tabletImage})`);
            firstWrap.style.backgroundImage = `url(${tabletImage})`;
          }
        } else {
          // Desktop - use CSS variable if set
          const desktopImage = firstWrap.style.getPropertyValue('--bg-image-desktop');
          if (desktopImage) {
            firstWrap.style.backgroundImage = desktopImage;
          }
        }
      });
    };
    
    updateBackgrounds();
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateBackgrounds, 100);
    });
  };
  
  applyResponsiveBackgrounds();
})();